import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../../../actions/navigationActions';
import { createQuoteFromPolicy, initiateWarrantySteps, setStep } from '../../../../actions/salesActions';
import { WARRANTY_JOURNEY_BUILDER, DASHBOARD } from '../../../../routes/routes';
import KPBreadCrumb from '../../../KPBreadCrumb/KPBreadCrumb';
import './GetWarranty.css';
import { refreshCart } from '../../../../actions/cartActions';
import { logEvent } from '../../../../firebase/firebase';

class GetCodeRed extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            loggedIn: this.props.auth.uid ? true : false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    componentWillMount() {
        logEvent('SSP_get_warranty_landed', 'user_landed_on_get_warranty');
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleRedirect() {
        logEvent('SSP_get_warranty_add_to_quote', 'user_cliked_get_a_quote_warranty');
        var nextPage = WARRANTY_JOURNEY_BUILDER;
        if (this.props.profile.policyId === "" && this.props.sales.quoteId === "") {
            await this.props.dispatchAction(initiateWarrantySteps());
            await this.props.dispatchAction(navigateTo(nextPage));
        }
        else if (this.props.profile.policyId !== "" && this.props.sales.quoteId === "") {
            await this.props.dispatchAction(createQuoteFromPolicy());
            if (this.props.sales.quoteId !== "")
            {
                await this.props.dispatchAction(refreshCart());
                await this.props.dispatchAction(initiateWarrantySteps());
                await this.props.dispatchAction(setStep(3, 1));
                await this.props.dispatchAction(navigateTo(nextPage));
            }
        }
        else {
            await this.props.dispatchAction(initiateWarrantySteps());
            await this.props.dispatchAction(setStep(3, 1));
            await this.props.dispatchAction(navigateTo(nextPage));
        }
    }

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]

        return (
            <div className={this.state.loggedIn ? "logged-in" : "logged-out"}>
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Get warranty" />
                <div className="row new-page-main-row justify-content-center">
                    <div className="col-12">
                        <div className="get-warrant-banner">
                            <div className="get-warrant-banner-content-left">
                                <div className="get-warrant-banner-content-image">
                                    <img alt="" title="" src="./Images/Warranty/WarrantyBanner.svg" />
                                </div>
                                <div className="get-warrant-banner-content-detail">
                                    <div className="get-warrant-banner-content-detail-title">
                                        Car warranty
                                    </div>
                                    <div className="get-warrant-banner-content-detail-text">
                                        Car warranty insurance keeps your car’s parts moving as they should
                                    </div>
                                </div>
                            </div>
                            <div className="get-warrant-banner-content-right">
                                <div className="text-center" style={{ width: "100%" }}>
                                    <button className="btn btn-solid-green mt-16px" onClick={this.handleRedirect}>Get a quote</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6 mb-15px">
                        <div id="WarrantyBenifits">
                            <h3 className="ml-20px">To get the king’s car warranty cover, you must:</h3>
                            <div className="">
                                <div className="col-12 mb-2 new-benefits-col">
                                    <div className="col-1 icon-checkmark-circle-32px"></div><p className="col-11 nopa noma ml-10px">Own a car. It doesn’t have to be insured with us… Or even insured at all. It just needs to exist.</p>
                                </div>
                                <div className="col-12 mb-2 new-benefits-col">
                                    <div className="col-1 icon-checkmark-circle-32px"></div><p className="col-11 nopa noma ml-10px">Be able to provide a full service history of the car.</p>
                                </div>
                                <div className="col-12 mb-2 new-benefits-col">
                                    <div className="col-1 icon-checkmark-circle-32px"></div><p className="col-11 nopa noma ml-10px">Reside permanently in SA.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-6">
                        <div id="WarrantyNotCovered">
                            <h3 className="ml-20px">Keep in mind:</h3>
                            <div className="">
                                <div className="col-12 mb-2 new-benefits-col">
                                    <img className="col-2 noma nopa warranty-image" alt="" title="" src="./Images/Warranty/WarrantyModifications.svg" />
                                    <div className="col-10">
                                        <p><b>Modifications</b></p>
                                        <p>We don't insure cars that have been modified in any way to increase performance.</p>
                                    </div>
                                </div>
                                <hr />
                                <div className="col-12 mb-2 new-benefits-col">
                                    <img className="col-2 noma nopa warranty-image" alt="" title="" src="./Images/Warranty/WarrantyMileage.svg" />
                                    <div className="col-10">
                                        <p><b>Cars with more than 200,000kms</b></p>
                                        <p>We don't cover cars that already have 200,000kms on the clock. However, if during your cover period, you reach 200,000kms, you'll still be covered for a certain percentage of your insured value.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile,
        auth: state.firebase.auth,
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(GetCodeRed);